import script from "./TutorialVideosModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialVideosModal.vue?vue&type=script&setup=true&lang=js"

import "./TutorialVideosModal.vue?vue&type=style&index=0&id=b664d4c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b664d4c4"]])

export default __exports__